import { METADATA_FIELD } from "../constants";

// Reglas puras del módulo userprofile. Sin React ni estado: entran datos, sale
// un valor. Los efectos (setState, mutaciones) quedan en los componentes.

/**
 * Convierte el array de campos del metadata de Zoho en las listas de valores que
 * alimentan los selects del formulario (países, perfiles, nacionalidades, géneros).
 * Si un campo no viene, devuelve una lista vacía para esa categoría.
 *
 * @param {Array} fields - `metadataData.fields` crudo del CRM.
 */
export const mapProfileMetadata = (fields: { apiName?: string; pickListValues?: unknown[] }[] = []) => {
  const valuesFor = (apiName: string) =>
    fields.find((field) => field.apiName === apiName)?.pickListValues ?? [];

  return {
    countries: valuesFor(METADATA_FIELD.COUNTRY),
    professionalProfile: valuesFor(METADATA_FIELD.PROFESSIONAL_PROFILE),
    nationalities: valuesFor(METADATA_FIELD.NATIONALITY),
    genres: valuesFor(METADATA_FIELD.GENDER),
  };
};

/**
 * Las dos contraseñas coinciden. El formulario arranca con ambas vacías, que
 * cuentan como iguales (el estado inicial del diálogo es "coinciden").
 */
export const passwordsMatch = (password?: string, repeatPassword?: string) => password === repeatPassword;

/**
 * Arma el payload de actualización de perfil SIN mutar el objeto del formulario:
 * agrega el perfil profesional seleccionado y el proyecto actual del usuario.
 */
export const buildProfileUpdatePayload = (
  formValues: Record<string, unknown>,
  professionalProfile?: unknown,
  currentProject?: unknown
) => ({
  ...formValues,
  professionalProfile,
  currentProject,
});
